<template>
  <div class="px-6">
    <v-row no-gutters align="center" class="pt-4">
      <span
        style="cursor: pointer"
        class="primary--text"
        @click="returnToOptions"
      >
        <v-icon small color="primary">mdi-chevron-left</v-icon>
        {{ $t("pixScreen.choosePaymentMethod") }}
      </span>
    </v-row>
    <v-row no-gutters class="mt-4">
      <label class="title-card">{{ $t("pixScreen.payWith") }}</label>
      <v-img
        max-height="24"
        width="72"
        max-width="72"
        class="ml-2"
        flat
        src="https://logospng.org/download/pix/logo-pix-1024.png"
      ></v-img>
    </v-row>
    <v-row
      no-gutters
      justify="center"
      style="min-width: 300px; min-height: 300px"
    >
      <div style="padding-top: 50px" v-if="loadingQRcode">
        <v-row no-gutters justify="center" class="mt-4 mb-4">
          <span class="footer-card">{{ $t("pixScreen.waitPlease") }}</span>
        </v-row>
        <v-row no-gutters justify="center">
          <v-progress-circular
            indeterminate
            size="60"
            color="primary"
          ></v-progress-circular>
        </v-row>
      </div>
      <v-img
        v-else-if="pixDetails"
        flat
        max-width="300"
        :src="`data:image/png;base64, ${pixDetails.qrcode_image.imagem_base64}`"
      ></v-img>
    </v-row>
    <div v-if="pixDetails">
      <v-row no-gutters v-if="$route.name !== 'totem'">
        <input
          type="hidden"
          id="copy-domain"
          readonly="readonly"
          :value="pixDetails.qrcode_image.emv"
        />
        <v-btn
          block
          rounded
          depressed
          class="normal-text mt-4"
          color="primary"
          dark
          @click="copyCode"
          :loading="pixDetails && !pixDetails.qrcode_image"
          >{{ $t("pixScreen.copyCode") }}</v-btn
        >
      </v-row>
    </div>
    <v-row no-gutters justify="center" class="mt-2 mb-4">
      <span class="footer-card">{{ $t("pixScreen.finish") }} </span>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      loadingQRcode: true,
      seconds: 0,
      intervalSeconds: null,
      countRequest: 0,
      timer: 3000,
      expired: false,
      pingRequest: true,
    };
  },
  computed: {
    ...mapGetters([
      "cartProducts",
      "pixDetails",
      "productsTotal",
      "orderDetails",
      "eventId",
    ]),
    productsDiscount() {
      let total = this.productsTotal;
      let discount = total * 0.05;
      return discount;
    },
  },
  watch: {
    pixDetails(v) {
      if (v && v.order_hash) {
        this.checkPurchaseStatus();
      }
      if (v && v.qrcode_image) {
        setTimeout(() => {
          this.loadingQRcode = false;
        }, 1500);
      }
    },
  },
  mounted() {
    this.pingRequest = true;
  },

  destroyed() {
    this.$store.commit("SET_PIX_DETAILS", null);
    this.pingRequest = false;
    clearInterval(this.intervalSeconds);
  },

  methods: {
    returnToOptions() {
      clearInterval(this.intervalSeconds);
      this.pingRequest = false;
      this.$emit("return");
    },
    async checkPurchaseStatus() {
      if (this.pingRequest) {
        try {
          let headers = { checkout: "one-checkout" };

          this.intervalSeconds = await setInterval(() => {
            if (this.pingRequest) this.incrementSeconds();
          }, 1000);

          this.countRequest += 1;
          if (this.countRequest >= 150) this.timer = 6000;

          const { data } = await axios.get(
            `pdv/orders/charge/status?order_hash=${
              this.orderDetails && this.orderDetails.hash_pedido
                ? this.orderDetails.hash_pedido
                : null
            }`,
            null,
            { headers }
          );
          clearInterval(this.intervalSeconds);
          if (data) {
            this.seconds = 0;
            clearInterval(this.intervalSeconds);
          }
          if (data && data.status !== "paid") {
            setTimeout(() => {
              if (this.pingRequest) this.checkPurchaseStatus();
            }, this.timer);
          } else if (data && data.status === "paid") {
            this.$store.commit("SET_FINAL_DETAILS", data);
            this.$router.push({
              name: "Finished",
              params: { event: this.eventId },
              query: this.$route.query,
            });
          }
        } catch (error) {
          clearInterval(this.intervalSeconds);
          throw error;
        }
      }
    },
    async incrementSeconds() {
      this.seconds += 1;
      if (this.seconds === 15) {
        this.seconds = 0;
        await clearInterval(this.intervalSeconds);
        this.checkPurchaseStatus();
      }
    },
    copyCode() {
      const pixLink = document.querySelector("#copy-domain");

      pixLink.setAttribute("type", "text");
      pixLink.select();

      try {
        document.execCommand("copy");
        this.copyBtn = "Copiado";
        this.$store.dispatch("openSnackbar", {
          message: "Link Copiado!",
          color: "success",
        });
      } catch (err) {
        this.$store.dispatch("openSnackbar", {
          message: "Erro ao copiar link, tente novamente!",
          color: "error",
        });
      }

      pixLink.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
};
</script>

<style scoped>
.link-btn {
  color: #1976d2;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.title-card {
  color: #192b46;
  font-size: 20px;
  font-weight: bold;
}

.subtitle-card {
  color: #192b46;
  font-size: 16px;
  font-weight: 500;
}

.discount {
  color: #00a65a;
  font-size: 16px;
  font-weight: 500;
}
.footer-card {
  color: #1976d2;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
</style>
